import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken, clearToken, getToken, formatApiError } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // null = checking, false = unauth, object = authed
    const [user, setUser] = useState(null);
    const [error, setError] = useState("");

    const fetchMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        if (getToken()) {
            fetchMe();
        } else {
            setUser(false);
        }
    }, [fetchMe]);

    const login = async (username, password) => {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { username, password });
            setToken(data.token);
            setUser(data.user);
            return true;
        } catch (e) {
            setError(formatApiError(e));
            return false;
        }
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (_) {}
        clearToken();
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, error, setError }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
};
